import Vue from 'vue'

export const crudMixin = Vue.extend({
  data() {
    return {
      crud: {},
      defaultCrud: {},
    }
  },
  methods: {
    resetCrud() {
      this.crud = JSON.parse(JSON.stringify(this.defaultCrud))
    },
  },
  created() {
    this.crud = JSON.parse(JSON.stringify(this.defaultCrud))
  },
})
